// OpenModal.jsx
import {
  Modal,
  ModalContent,
  ModalBody,
  useDisclosure
} from "@heroui/react";


const OpenModal = ({ isOpen, onOpenChange, modalMessage }) => {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      classNames={{
        backdrop: "bg-black/35",
        wrapper: "flex items-center justify-center min-h-screen sm:-mt-10 md:-mt-8",
      }}
    >
      <ModalContent>
        {(onClose) => (
          <ModalBody className="flex items-center justify-center min-h-[80px] p-0">
            <p className="text-center font-semibold">{modalMessage}</p>
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  );
};

export default OpenModal;
